import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { createApplication } from '../../api/applications.js'
import ApplicationForm from '../../components/applications/ApplicationForm.jsx'

export default function ApplicationCreatePage() {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)

  async function handleSubmit(values) {
    setIsSubmitting(true)
    setError(null)

    try {
      const createdApplication = await createApplication(values)
      if (createdApplication?.id) {
        navigate(`/applications/${createdApplication.id}/configs`)
      } else {
        navigate('/applications')
      }
    } catch (submitError) {
      setError(submitError)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="page">
      <div className="pageHeader">
        <h1 className="pageTitle">Create application</h1>
        <Link to="/applications" className="button buttonGhost">
          Back to list
        </Link>
      </div>

      <ApplicationForm
        initialValues={null}
        onSubmit={handleSubmit}
        submitLabel="Create"
        isSubmitting={isSubmitting}
        error={error}
      />
    </div>
  )
}
